import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles(() =>
  createStyles({
    page_wrapper: {},
    page_content: {
      padding: '0',
      height: 'calc(100vh - 80px)',

      '& .MuiPaper-root': {
        background: '#fff',
        height: '100%',
        transition: '0.3s',
      },
      '& .Mui-TableHeadCell-Content-Labels': {
        alignItems: 'flex-start',

        '& .MuiBadge-root': {
          position: 'absolute',
          right: 5,
        },

        '& .Mui-TableHeadCell-Content-Wrapper:not(:last-child)': {
          '& >div>span:first-child': {
            display: 'block',
            paddingRight: 20,
          },
          '& >div>span:nth-child(2)': {
            display: 'block',
            paddingRight: 0,
          },
        },
      },
      '& .MuiBadge-root': {
        transform: 'translateY(3px)',
      },
      '& .MuiBox-root': {
        background: '#fff',
      },
      '& .MuiTableContainer-root': {
        height: 'calc(100% - 56px)',
        maxHeight: '100%',
        transition: '0.3s',
      },
      '& .MuiTableRow-root': {
        backgroundColor: 'transparent !important',
        '&:hover': {
          '& td': {
            backgroundColor: 'rgb(242, 242, 242) !important',
          },
        },
      },

      '& th': {
        '&:not(:nth-child(2))': {
          '& .Mui-TableHeadCell-Content': {},
        },

        '&:first-child': {
          paddingLeft: 35,
        },
        padding: 0,
        fontWeight: 800,
        fontSize: 14,
        textAlign: 'right',
        justifyContent: 'flex-start',

        '& hr': {
          borderColor: 'transparent',
        },
        '& .Mui-TableHeadCell-Content': {
          width: '100%',
          height: '100%',
          padding: '15px 12px 10px',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
        },

        '& th:first-child': {
          '& .Mui-TableHeadCell-ResizeHandle-Wrapper': {
            display: 'none',
          },
        },

        '&:last-child': {
          display: 'none',
        },

        '& .Mui-TableHeadCell-ResizeHandle-Wrapper': {
          width: 1,
          background: 'transparent',
          height: '100%',
          top: 0,
          bottom: 0,
          right: '15px',
        },
      },
      '& th:not(:last-child)': {
        borderRight: '1px solid rgba(196, 196, 196, 0.25)',
      },
      '& tr': {
        '&:hover': {
          '& td': {
            // backgroundColor: 'rgb(242, 242, 242) !important',
          },
        },
        '& td': {
          // borderBottom: '1px solid rgba(196, 196, 196, 0.25)',
          // fontWeight: 300,
          // fontSize: 14,
          // textTransform: 'capitalize',
          // padding: 12,
          '&:first-child': {
            paddingLeft: 45,
          },

          justifyContent: 'flex-start',
          textAlign: 'right',
          '&:last-child': {
            display: 'none',
          },
        },
        '& td:not(:last-child)': {
          borderRight: '1px solid rgba(196, 196, 196, 0.25)',
        },
      },
    },
    td_platform_icon: {
      width: 20,
      height: 20,
      marginRight: 5,
      '& > *': {
        width: '100%',
        height: '100%',
      },
    },
    td_platform: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    page_channel: {
      height: '100%',
    },
    page_account: {
      '&:not(:last-child)': {
        marginBottom: 85,
      },
    },
    headline: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    },
    headline_link: {
      display: 'flex',
      alignItems: 'center',
    },
    headline_btn: {
      minWidth: 205,
      '&:not(:last-child)': {
        marginRight: 28,
      },
    },
    td_product: {
      width: '100%',
      display: 'flex',
      flexWrap: 'nowrap',
      justifyContent: 'space-between',
      gap: '20px',
      alignItems: 'center',
    },
    wrapperBtn: {
      width: 102,
      textAlign: 'center',
      '&:not(:first-of-type)': {
        marginLeft: '0 !important',
      },
      '& > a': {
        display: 'flex',
        textDecoration: 'none',
      },
      '& .MuiButtonBase-root': {
        minHeight: 25,
        height: 40,
        border: '1px solid #1A0063',
        color: '#1A0063',
        transition: '0.3s',
        fontSize: 11,
        textTransform: 'unset',
        padding: 8,
        '&.Mui-disabled': {
          borderColor: '#C4C4C4',
          color: '#C4C4C4',
        },
        '&:hover': {
          backgroundColor: '#1A0063',
          color: '#fff',
        },
      },
    },
  })
)
export default useStyles
